import { useEffect } from 'react';
import { isEventOriginIncludesLiberisUrl } from '@repo/env';
import { activityType } from '@repo/shared/types';
import { useEventClick } from '@repo/hooks';

import { useMainHubStoreState } from '@/store/main-hub.store';

export const useLiberisIframeEvent = (handleSignVerify: () => void, isPending: boolean) => {
  const { merchantResponseData } = useMainHubStoreState();
  const trackClick = useEventClick(merchantResponseData);

  useEffect(() => {
    window.parent.postMessage({ type: 'READY' }, '*');
  }, []);

  function handleIframeAction(evt: MessageEvent) {
    if (!isEventOriginIncludesLiberisUrl(evt.origin)) {
      console.warn('application not embeddable at this URL');
    } else if (evt.data) {
      const parsedData = JSON.parse(evt.data);

      if (parsedData.status === 'download-requested' && parsedData.url) {
        window.open(parsedData.url, '_blank');
      }

      if (parsedData.status === 'ContractComplete' && !isPending) {
        trackClick({ activity: activityType.enum.LIBERIS_AGREEMENT_SIGN });
        handleSignVerify();
      }

      if (parsedData.status === 'ContractFailure') {
        // TODO: ustawić modal z widokiem błędu i przekierować na dashboard
        console.warn('ContractFailure');
      }
    } else {
      console.warn('no hash found for this URL');
    }
  }

  useEffect(() => {
    window.addEventListener(
      'message',
      (evt) => {
        handleIframeAction(evt);
      },
      false,
    );

    return () => {
      window.removeEventListener('message', handleIframeAction);
    };
  }, []);
};
